import * as braze from '@braze/web-sdk';
import { Braze } from '@foxcorp/cpe-commerce-web';
import { getDefaultConfig, getState } from 'Utils/Store';
import { BRAZE_ZONES, MY_ACCOUNT_TOP, MY_ACCOUNT_2ND, CANCEL_INTERRUPT } from 'Utils/Constants';
import { setContentCards } from 'State/ContentCards';

export const setBrazeUserLoggedIn = (loggedIn) => braze.getUser().setCustomUserAttribute('u_log_stat_web', loggedIn);

export const setBrazeUser = (profileId) => {
  const {
    user: { isAuthenticated },
  } = getState();
  const { nodeEnv } = getDefaultConfig();
  braze.changeUser(profileId);
  if (nodeEnv === 'development') {
    braze.requestImmediateDataFlush();
  }
  setBrazeUserLoggedIn(!!isAuthenticated);
};

// initialize the SDK
export const initBraze = (profileId) => {
  const { brazeApiKey, enableBrazeLogging } = getDefaultConfig();
  braze.initialize(brazeApiKey, {
    baseUrl: 'sdk.iad-05.braze.com',
    // logging based on environment
    enableLogging: enableBrazeLogging,
    allowUserSuppliedJavascript: true,
  });

  // set user for braze session
  const brazeUser = profileId;
  if (brazeUser) {
    setBrazeUser(brazeUser);
  }

  // init braze content cards (banners)
  braze.requestContentCardsRefresh();
  braze.subscribeToContentCardsUpdates((content) => {
    const sortedContentCards = content.cards.sort((a, b) => Date.parse(b.updated) - Date.parse(a.updated));
    const filteredContentCards = BRAZE_ZONES.map((zone) => {
      // 1. Find all content cards in zone
      // 2. Return prioritized content card using prioritize KVP in extras settings
      // 3. If not, return first one in sorted cards
      const allCardsInZone = sortedContentCards.filter((banner) => banner.extras.zone === zone);
      const prioritizedCard = allCardsInZone.find((card) => card.extras?.prioritize === 'true');
      const latestCard = allCardsInZone.find((banner) => banner.extras.zone === zone);
      return prioritizedCard ? prioritizedCard : latestCard;
    }).filter((item) => item !== undefined);
    setContentCards(filteredContentCards);
  });

  // subscribe to braze IAM
  braze.automaticallyShowInAppMessages();

  // init braze session
  braze.openSession();

  initBrazeActions();
};

const initBrazeActions = () => {
  const { foxApi, accountApiKey } = getDefaultConfig();
  Braze.createActions({
    apiKey: accountApiKey,
    apiUrl: foxApi,
  });
};

// Checks for an existing content card to display in the zone
export const hasBrazeContentCard = (zone) => {
  const contentCards = getState('contentCards').allContentCards;
  return contentCards.some((contentCard) => contentCard.extras.zone === zone);
};

// Braze listens on a custom card removal events and remove the banner
export const getCustomEvent = (zone) => {
  switch (zone) {
    case MY_ACCOUNT_TOP:
      return 'My_Account_Web_Banner_Click';
    case MY_ACCOUNT_2ND:
      return 'My_Account_Web_Banner_Click';
    case CANCEL_INTERRUPT:
      return 'Cancel_Interrupt_Web_Banner_Click';
    default:
      break;
  }
};

export const getContentCardByZone = (contentCards, zone) => {
  return contentCards.filter((contentCard) => contentCard.extras.zone === zone)[0];
};

// returns the path minus the last part of the path & replacing it with "/*"
export const getPathRoot = (path) => {
  const pathRoot = path.replace(/\/[^/]*\/?$/, '/*');
  return pathRoot;
};

export const getContentCardCampaignType = (contentCard) => contentCard?.extras.campaign_type;
